import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    leadList: [],
    leadArr: [],
    leadArray: [],
    leadID: "",
    leadName: "",
    selectedLead: null,
    selectedSource: null,
    selectedChannel: null,
    selectedRep: null,
    isEditing: "",

  };
  
  const mutations = {
    initializeStore(state){
      state.leadList = [];
      state.leadArr = [];
      state.leadArray = [];
      state.leadID = '';
      state.leadName = '';
      state.selectedLead = null;
      state.selectedSource = null;
      state.selectedChannel = null;
      state.selectedRep = null;
      state.isEditing = false;
    },
    SET_SELECTED_LEAD(state, lead) {
      state.selectedLead = lead;
      state.isEditing = true;
    },
    LEADS_ARRAY(state, leads){
      state.leadArray = leads;
    },
    LIST_ASSET_LEADS(state, leads) {
      state.leadList = leads;
    },
    SET_SELECTED_SOURCE(state, source) {
      state.selectedSource = source;
    },
    SET_SELECTED_CHANNEL(state, channel) {
      state.selectedChannel = channel;
    },
    SET_SELECTED_REP(state, rep) {
      state.selectedRep = rep;
    },
    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){
         
      }
    },
    RESET_SEARCH_FILTERS(state){
     
    }

  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },
    
    async createMarketingLead({ commit,state }, formData) {
      return axios.post('api/v1/create-marketing-lead/', formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
    },
  
    fetchMarketingLeads({ commit,state }, formData) {
      state.leadArr = [];
      axios.post(`api/v1/get-marketing-leads/`,formData)
      .then((response)=>{
        for(let i=0; i< response.data.length; i++){
          state.leadArr.push((response.data[i].full_name + " - " + response.data[i].email));
        }
        commit('LIST_ASSET_LEADS', response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchMarketingLead({ commit,state }, formData) {
      axios.post(`api/v1/get-marketing-leads/`,formData)
      .then((response)=>{
        state.selectedLead = response.data;
        const selectedSource = (response.data.lead_source != null) ? (response.data.lead_source.name)  : "";
        const selectedRep = (response.data.sales_rep != null) ? (response.data.sales_rep.name  + " - Email: " + response.data.sales_rep.email)  : "";
        const selectedChannel = (response.data.campaign_source != null) ? (response.data.campaign_source.channel.name)  : "";
        
        commit('SET_SELECTED_LEAD',response.data);
        commit('SET_SELECTED_SOURCE',selectedSource);
        commit('SET_SELECTED_CHANNEL',selectedChannel);
        commit('SET_SELECTED_REP',selectedRep);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    handleSelectedLead({ commit, state }, option){
      state.leadArray = [];
      const selectedLead = state.leadList.find(lead => (lead.full_name + " - " + lead.email) === option);
      if (selectedLead) {
          state.leadID = selectedLead.lead_id;
          state.leadName = selectedLead.full_name;
          state.leadArray = [...state.leadArray, selectedLead];
      }
      commit('LEADS_ARRAY', state.leadArray);
        
    },
  
    async updateMarketingLead({ commit,state }, formData) {
      return axios.put(`api/v1/update-marketing-lead/`,formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })  
    },
  
    deleteMarketingLead({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Lead?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Lead!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-marketing-lead/`,formData)
          .then((response)=>{
            if(response.status == 200){
                Swal.fire("Poof! Lead removed succesfully!", {
                  icon: "success",
                }); 
            }else{
              Swal.fire({
                title: "Error Deleting Lead",
                icon: "warning",
              });
            }                   
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Lead has not been deleted!`);
        }
      })
    },
  };
  
  const getters = {
    // users: (state) => state.users,
    // currentUser: (state) => state.currentUser,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  